import React from "react";
import { connect } from "react-redux";
import { NavLink, Link } from "react-router-dom";
import { Select } from "semantic-ui-react";
import Logo from "../images/mums.png";
import Hamburger from "../images/ico-hamburger.svg";
import IcoClose from "../images/ico-close-popup.svg";
import { setKmsId } from "../_actions/kms.actions";
import { getMenu } from "../_actions/cms.actions";
import { getAllPageLanguages } from "../_actions/common.actions";
import { withTranslation } from "react-i18next";
import CountrySpecificKPModal from "./modal/CountrySpecificKPModal";
import { getBySymbol } from "../_actions/pagelangs.actions";
import { compose } from "redux";
import detectBrowserLanguage from "detect-browser-language";
import { min } from "lodash";

function browserLanguage() {
    var brslang = detectBrowserLanguage();

    if (brslang.includes("-")) {
        var spl = brslang.split("-");
        brslang = spl[0].toString().toUpperCase();
    } else {
        brslang = brslang.toUpperCase();
    }
    return brslang ?? "EN";
}

class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            webPages: [],
            isOpenMobileMenu: false,
            showLogin: process.env.REACT_APP_SHOWLOGIN === "true",
            translation: "",
            showModal: false,
            countrySpecificKPText: "",
            browserLanguage: browserLanguage(),
            browserLanguageName: "",
            brslang: "EN",
            display: "block",
        };
    }
    toggleDisplay = () => {
        this.setState((prevState) => ({
            display: "none",
        }));
    };

    handleTrans = (e, { name, value }) => {
        //console.log("value", value);
        //console.log("name", name);
        const { i18n, getBySymbol } = this.props;
        var selectedLang = value.toUpperCase();
        //console.log("selectedLang", selectedLang);
        getBySymbol(selectedLang).then((response) => {
            if (response.isCountrySpecific)
                this.setState({
                    showModal: true,
                    countrySpecificKPText: response.textForCountrySpecificKB,
                });
        });
        i18n.changeLanguage(value);
        this.setState({ translation: value });
    };

    openMobileMenu = () => {
        this.setState({ isOpenMobileMenu: true });
        document.body.style.overflow = "hidden";
    };
    closeMobileMenu = () => {
        this.setState({ isOpenMobileMenu: false });
        document.body.style.overflow = "auto";
    };

    componentDidMount() {
        if (!this.props.menu) {
            this.props.getMenu().then((webPages) => {
                this.setState({ webPages });
            });
        }
        //console.log("browserLanguage", this.state.browserLanguage);
        //console.log("localStorage.getItem(i18nextLng)", localStorage.getItem("i18nextLng"));
        //console.log("translation", this.state.translation);
        //console.log("localStorage.getItem(user)", localStorage.getItem("user"));

        var brslang = this.state.translation ? this.state.translation : "EN"; // localStorage.getItem("user") ? localStorage.getItem("i18nextLng") : "EN";

        //var brslang = localStorage.getItem("i18nextLng");

        if (brslang !== null) {
            if (brslang.includes("-")) {
                var spl = brslang.split("-");
                brslang = spl[0].toString().toUpperCase();
            } else {
                brslang = brslang.toUpperCase();
            }
        } else brslang = "EN";
        //console.log("brslang", brslang);

        this.setState({ brslang: brslang });
        this.setState({ translation: brslang });

        if (!this.props.pagelanguages) this.props.getAllPageLanguages();

        if (brslang === this.state.browserLanguage) {
            this.setState({ display: "none" });
        }
        // if (this.props.pagelanguages) {
        //     const foundItem = this.props.pagelanguages.find((item) => item.value === this.state.browserLanguage);
        //     if (foundItem) {
        //         this.setState({ browserLanguageName: foundItem.text });
        //         //console.log("foundItem", foundItem);
        //     }
        // }
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.pagelanguages !== this.props.pagelanguages) {
            //console.log("this.props.pagelanguages", this.props.pagelanguages);
            if (this.props.pagelanguages) {
                const actvLang = this.state.brslang;
                const foundItem = this.props.pagelanguages.find((item) => item.value === actvLang);
                if (foundItem) {
                    //this.setState({ browserLanguageName: foundItem.text });
                    //console.log("foundItem", foundItem);
                    this.handleTrans(null, { name: "translation", value: actvLang });
                }
                const browserLanguageName = this.props.pagelanguages.find(
                    (item) => item.value === this.state.browserLanguage
                );
                if (browserLanguageName) {
                    this.setState({ browserLanguageName: browserLanguageName.text });
                }
            }
        }
    }

    renderMenuItems(isMobile) {
        const { translation, webPages } = this.state;
        if (!this.props.menu) return null;

        return this.props.menu
            .filter((menuItem) => !!webPages.find((x) => x.id === menuItem.cmsPageId))
            .map((menuItem, inx) => {
                let webpage = webPages.find((x) => x.id === menuItem.cmsPageId);
                let title = "";
                if (translation === "EN") title = menuItem.title;
                else {
                    var trTitles = menuItem.translationPages.filter((trPage) => trPage.langSymbol === translation);
                    title = trTitles.length > 0 ? trTitles[0].title : menuItem.title;
                }
                return !webpage ? null : (
                    <li key={inx} className={isMobile ? "" : "main-nav__item"}>
                        {isMobile && <a href={`/pages/${webpage.seoUrl}`}>{title}</a>}
                        {!isMobile && (
                            <NavLink
                                state={{ webPageId: webpage.id, title: webpage.title }}
                                className="main-nav__link"
                                to={`/pages/${webpage.seoUrl}`}
                            >
                                {title}
                            </NavLink>
                        )}
                    </li>
                );
            });
    }

    closeModal = () => this.setState({ showModal: false, countrySpecificKPText: "" });

    render() {
        const { loggedIn, headerWithShadow, pagelanguages, t } = this.props;
        const {
            isOpenMobileMenu,
            showLogin,
            translation,
            showModal,
            countrySpecificKPText,
            browserLanguage,
            browserLanguageName,
        } = this.state;
        return (
            <header className={`header${headerWithShadow ? " header--shadow" : ""}`}>
                {isOpenMobileMenu && (
                    <div className="mobile-menu">
                        <button className="mobile-menu__close" onClick={this.closeMobileMenu} title="close">
                            <img src={IcoClose} alt="" />
                        </button>
                        <ul className="mobile-menu__list">
                            <li>
                                <a href="/" className="paddingBottom-15">
                                    <img src={Logo} alt="logo" width="200" />
                                </a>
                            </li>
                            <li>
                                <a href="/">{t("Home")}</a>
                            </li>
                            {this.renderMenuItems(true)}
                            {showLogin === true && (
                                <li>
                                    <a href={`/${!loggedIn ? "login" : "admin/knowledge"}`}>
                                        {!loggedIn ? "Sign in" : "Information pages"}
                                    </a>
                                </li>
                            )}
                        </ul>
                    </div>
                )}
                <CountrySpecificKPModal open={showModal} onClose={this.closeModal} desc={countrySpecificKPText} />
                <div
                    className="container"
                    style={{ marginTop: process.env.REACT_APP_SHOWBANNER !== "true" ? "0px" : "30px" }}
                >
                    <div className="header__row">
                        {pagelanguages && (
                            <>
                                <div
                                    style={{
                                        border: "1px solid #a2d7f3",
                                        borderRadius: "10px",
                                        display: "flex",
                                        marginLeft: "auto",
                                        marginRight: "10px",
                                    }}
                                >
                                    {browserLanguage && (
                                        <span
                                            className="cursorPinter_color"
                                            style={{
                                                marginTop: "10px",
                                                marginBottom: "10px",
                                                marginLeft: "10px",
                                                paddingRight: "10px",
                                                borderRight: "1px solid black",
                                                cursor: "pointer",
                                                display: this.state.display,
                                            }}
                                            onClick={() => {
                                                //console.log("browserLanguage", browserLanguage);
                                                this.handleTrans(null, { name: "translation", value: browserLanguage });
                                                this.toggleDisplay();
                                                this.setState({ brslang: browserLanguage });
                                            }}
                                        >
                                            {browserLanguageName}
                                        </span>
                                    )}
                                    <Select
                                        options={pagelanguages}
                                        placeholder="Language"
                                        selection
                                        //onChange={this.handleTrans}
                                        onChange={(e, data) => {
                                            this.handleTrans(e, { ...data });
                                            this.toggleDisplay();
                                        }}
                                        value={translation}
                                        name="translation"
                                        className="customDD"
                                        style={{ minWidth: "0px !important" }}
                                    />
                                </div>
                            </>
                        )}
                    </div>
                    <div className="header__row">
                        <div className="header__left">
                            <Link to="/" className="header__logo" onClick={() => this.props.setKmsId(0)}>
                                <img src={Logo} alt="logo" width="250" />
                            </Link>
                        </div>
                        <div className="header__right">
                            <nav className="main-nav">
                                <ul className="main-nav__list">
                                    <li className="main-nav__item">
                                        <NavLink
                                            className="main-nav__link"
                                            to="/"
                                            onClick={() => this.props.setKmsId(0)}
                                        >
                                            {t("Home")}
                                        </NavLink>
                                    </li>
                                    {this.renderMenuItems(false)}
                                    {showLogin === true && (
                                        <li>
                                            <NavLink
                                                className="main-nav__link"
                                                to={`/${!loggedIn ? "login" : "admin/knowledge"}`}
                                            >
                                                {!loggedIn ? "Sign in" : "Information pages"}
                                            </NavLink>
                                        </li>
                                    )}
                                </ul>
                            </nav>
                            <button className="header__hamburger" onClick={this.openMobileMenu} title="open">
                                <img src={Hamburger} alt="" />
                            </button>
                        </div>
                    </div>
                </div>
            </header>
        );
    }
}
const mapStateToProps = (state) => {
    const { pagelanguages } = state.common;
    return {
        loggedIn: state.authentication.loggedIn,
        menu: state.website.menu,
        pagelanguages: pagelanguages,
    };
};
const mapDispatchToProps = {
    setKmsId,
    getMenu,
    getAllPageLanguages,
    getBySymbol,
};
export default compose(connect(mapStateToProps, mapDispatchToProps), withTranslation())(Header);
